"use client";

import { useMemo, useState } from "react";
import localise from "@/components/localise";
import PartnerCard from "@/components/PartnerCard";
import { useFilterPartners } from "@/hooks/useFilterPartners";

const PartnersContent = ({ partners, promotedPartners, totalCount }) => {
  const [filterPartnerTitle, setFilterPartnerTitle] = useState("");
  const foundPartners = useFilterPartners(partners, filterPartnerTitle);

  const categoryPartners = useMemo(() => {
    const result = {};
    for (const partner of foundPartners) {
      const partnerCategory = partner?.categories?.[0];
      if (!partnerCategory) {
        continue;
      }
      const categoryEntry = result[partnerCategory.slug] || {
        category: partnerCategory,
        partners: [],
      };
      categoryEntry.partners.push(partner);
      result[partnerCategory.slug] = categoryEntry;
    }
    const sortedCategories = Object.values(result)
      .sort(
        (a, b) =>
          a.category.weight - b.category.weight ||
          a.category.title.localeCompare(b.category.title),
      )
      .map((entry) => [entry.category.slug, entry]);

    return Object.fromEntries(sortedCategories);
  }, [foundPartners]);

  return (
    <div className="container max-w-(--breakpoint-lg) mt-3 mb-4 md:mb-5">
      <h1 className="my-5 md:my-10 text-xl md:text-4xl lg:text-5xl font-black">
        {localise("partners.index.heading", { count: totalCount })}
      </h1>

      <input
        type="search"
        className="input text-lg md:text-xl p-2 md:p-3 mr-3 mb-5 md:mb-30 border border-gray-200 rounded-sm"
        value={filterPartnerTitle}
        onChange={(e) => setFilterPartnerTitle(e.target.value)}
        placeholder={localise("common.placeholder")}
      />

      {!filterPartnerTitle && promotedPartners?.length > 0 && (
        <div className="py-3 md:py-8 mb-3">
          <h3 className="text-2xl md:text-3xl font-black mb-5">
            {localise("partners.index.promotedPartners")}
          </h3>
          <div className="grid grid-cols-1 gap-3 sm:gap-4 sm:grid-cols-2 md:grid-cols-3">
            {promotedPartners?.map((partner) => (
              <PartnerCard partner={partner} key={`promoted-${partner.id}`} />
            ))}
          </div>
        </div>
      )}

      {Object.entries(categoryPartners).map(
        ([categorySlug, { category, partners }]) => (
          <div key={categorySlug} className="py-3 md:py-8 mb-10">
            <h3
              id={category.slug}
              className="text-2xl md:text-3xl font-black mb-5"
            >
              {category.title}
            </h3>
            <div className="grid grid-cols-1 gap-3 sm:gap-4 sm:grid-cols-2 md:grid-cols-3">
              {partners.map((partner) => (
                <PartnerCard partner={partner} key={partner.slug} />
              ))}
            </div>
          </div>
        ),
      )}
    </div>
  );
};

export default PartnersContent;
